import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ArrowSquareOut } from "@phosphor-icons/react/ArrowSquareOut";
import { X } from "@phosphor-icons/react/X";
import { paths } from "config/paths";
import { FC } from "react";
import { useWebRouter } from "~utils/next-router/use-web-router";

import { Map } from "~ui-components/types/__generated/gql/graphql";

export interface DataInUseModalModalProps {
	onClose: () => void;
	maps: Map[];
}

export const DataInUseModalModal: FC<DataInUseModalModalProps> = ({
	onClose,
	maps,
}) => {
	const router = useWebRouter();

	return (
		<Dialog open>
			<DialogTitle>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					gap={1}>
					Data in use
					<IconButton onClick={onClose}>
						<X />
					</IconButton>
				</Stack>
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					mb={2}>
					This dataset cannot be deleted because it is still being used by
					layers in the following maps. Please delete the layers using this
					dataset first.
				</Typography>
				<Typography
					variant="subtitle2"
					color="text.secondary"
					mb={2}>
					Maps using this data:
				</Typography>
				<List
					sx={{
						"& .MuiListItem-root": {
							justifyContent: "space-between",
							px: 0,
							py: 0,
						},
					}}>
					{maps.map((map) => (
						<ListItem key={map.id}>
							<Typography variant="subtitle2">{map.name}</Typography>
							<IconButton
								href={paths.accountName.maps.mapId.mapName.root(
									router._query.accountName,
									map.id,
									map.name,
								)}
								target="_blank">
								<ArrowSquareOut />
							</IconButton>
						</ListItem>
					))}
				</List>
			</DialogContent>
		</Dialog>
	);
};
